jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'JO') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagejo'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'SA') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagesa'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'QA') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageqa'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'BH') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagebh'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'PT') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagept'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'BR') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagebr'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'CO') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageco'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'MX') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagegb'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'ES') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagees'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'AU') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageau'));
    }
  }
} );


jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'CA') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageca'));
    }
  }
} );


    
jQuery.ajax( {
  
  
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'US') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageus'));
    }
  }
} );
    

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'GB') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagegb'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'FR') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagefr'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'IT') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageit'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'DE') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagede'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'JP') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messagejp'));
    }
  }
} );

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(location) {
    // If the visitor is browsing from Canada.
    if (location.country_code === 'AT') {
      // Tell him about the Canadian store.
      jQuery.fancybox.open(jQuery('#messageat'));
    }
  }
} );


